// extracted by mini-css-extract-plugin
export default {"AddFolder":"_AddFolder--QTOwP","Tree":"_Tree--diiII","Header":"_Header--Y4rsx","Title":"_Title--SqxOH","Small":"_Small--dT0_X","BranchContainer":"_BranchContainer--qQNzu"};